import { useExpiryCountdown } from '../../hooks/useExpiryCountdown';
import './styles/GalleryCountdown.css';

interface Props {
  /** ISO timestamp indicating when the batch stops being displayed. */
  expiryTime: string | null | undefined;
  /** Optional label shown beside the number. */
  label?: string;
}

/**
 * Visible, blinking countdown for how long the current results batch remains
 * on screen. Derived from an expiry timestamp so it stays in sync with the
 * backend. The number re-triggers a blink animation on every tick to capture
 * engagement, and turns "urgent" in the final seconds.
 */
const GalleryCountdown: React.FC<Props> = ({
  expiryTime,
  label = 'Next in',
}) => {
  const seconds = useExpiryCountdown(expiryTime);

  if (!expiryTime || seconds <= 0) return null;

  const isUrgent = seconds <= 5;

  return (
    <div
      className={`gallery-countdown ${isUrgent ? 'gallery-countdown--urgent' : ''}`}
      role="timer"
      aria-live="polite"
      aria-label={`${label} ${seconds} seconds`}
    >
      <span className="gallery-countdown__label">{label}</span>
      {/* key forces the blink animation to restart each second */}
      <span key={seconds} className="gallery-countdown__value">
        {seconds}
        <span className="gallery-countdown__unit">s</span>
      </span>
    </div>
  );
};

export default GalleryCountdown;
